/**
 * The fastpanel epic.
 *
 * This waits for FASTPANEL_LOADED and then fires off all tracking events waiting in the queue.
 */

import { FASTPANEL_LOADED } from '../redux/fastpanel';
import { listenForConsent } from '../redux/gdpr';

import { Observable } from 'rxjs';
import trackFastpanel, { fastpanelQueue } from '../utils/fastpanel';

import type { ActionObs, Obs, Store, TrackedEvent } from '../types';

export default function fastpanelEpic(action$: ActionObs, store: Store): Obs {
  return action$.ofType(FASTPANEL_LOADED).flatMap(action => {
    fastpanelQueue.forEach((event: TrackedEvent) => {
      trackFastpanel(event);
    });

    // I believe this is the best way to clear an array.
    fastpanelQueue.length = 0;
    return Observable.of(listenForConsent());
  });
}
